import styled from '@emotion/styled/macro'

export default styled as (...args: any[]) => <T>(...args: any[]) => React.FC<T>
